export default __webpack_public_path__ + "static/media/pc-banner-white.46427517.png";